<template>
  <div>
    <row>
      <col12>
        <v-card elevation="2">
          <v-card-text>
            <div class="icon-title">
              <v-icon>mdi-devices</v-icon>
              <b>{{ $t('myprofile.trusted_devices') }}</b>
            </div>
            <p class="text-body-2 mb-4">
              {{ $t('myprofile.trusted_devices_description') }}
            </p>
            
            <v-alert
              v-if="devices.length === 0"
              type="info"
              text
            >
              {{ $t('myprofile.no_trusted_devices_found') }}
            </v-alert>
            
            <v-list v-else>
              <v-list-item
                v-for="device in devices"
                :key="device.id"
                three-line
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ device.device_name || $t('myprofile.unknown_device') }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="text-caption">
                      <strong>{{ $t('myprofile.ip_address') }}:</strong> {{ device.ip_address || $t('myprofile.unknown') }}<br>
                      <strong>{{ $t('myprofile.trusted') }}:</strong> {{ formatDate(device.trusted_at) }}<br>
                      <strong>{{ $t('myprofile.expires') }}:</strong> {{ formatDate(device.expires_at) }}<br>
                      <strong>{{ $t('myprofile.last_used') }}:</strong> {{ formatDate(device.last_used_at) }}
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                
                <v-list-item-action>
                  <v-btn
                    color="error"
                    small
                    outlined
                    @click="revokeDevice(device.id)"
                    :loading="revoking === device.id"
                  >
                    {{ $t('myprofile.revoke') }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            
            <v-divider class="my-4"></v-divider>
            
            <v-btn
              v-if="devices.length > 0"
              color="error"
              outlined
              @click="revokeAllDevices"
              :loading="revokingAll"
            >
              <v-icon left>mdi-delete</v-icon>
              {{ $t('myprofile.revoke_all_devices') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </col12>
    </row>
  </div>
</template>

<script>
import Row from "@/components/layout/Row";
import Col12 from "@/components/layout/Col12";

export default {
  name: 'TrustedDevices',
  components: {Row, Col12},
  data() {
    return {
      devices: [],
      revoking: null,
      revokingAll: false,
      loading: false
    }
  },
  async mounted() {
    await this.loadDevices()
  },
  methods: {
    async loadDevices() {
      try {
        this.loading = true
        const response = await this.$api.user.get_trusted_devices()
        if (response) {
          this.devices = response
        }
      } catch (error) {
        console.error('Error loading trusted devices:', error)
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('myprofile.failed_to_load_trusted_devices'))
      } finally {
        this.loading = false
      }
    },
    
    async revokeDevice(deviceId) {
      try {
        this.revoking = deviceId
        const response = await this.$api.user.revoke_trusted_device(deviceId)
        if (response && response.success) {
          await this.$store.dispatch('snackbars/add_success_snack', this.$t('myprofile.device_revoked_successfully'))
          await this.loadDevices()
        }
      } catch (error) {
        console.error('Error revoking device:', error)
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('myprofile.failed_to_revoke_device'))
      } finally {
        this.revoking = null
      }
    },
    
    async revokeAllDevices() {
      try {
        this.revokingAll = true
        const response = await this.$api.user.revoke_all_trusted_devices()
        if (response && response.success) {
          await this.$store.dispatch('snackbars/add_success_snack', this.$t('myprofile.all_devices_revoked_successfully'))
          await this.loadDevices()
        }
      } catch (error) {
        console.error('Error revoking all devices:', error)
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('myprofile.failed_to_revoke_all_devices'))
      } finally {
        this.revokingAll = false
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return this.$t('myprofile.unknown')
      try {
        return new Date(dateString).toLocaleString()
      } catch (error) {
        return this.$t('myprofile.invalid_date')
      }
    }
  }
}
</script>

<style scoped>
.icon-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.icon-title v-icon {
  margin-right: 8px;
}
</style> 